import request from '@/utils/request.js'
import requests from '@/utils/requests.js'

// 获取首页数据
export function index(data) {
	return request({
		url: '/api/index/index',
		method: 'GET',
		params: data,
	})
}

// 获取关于我们列表
export function fundServicesList(data) {
	return request({
		url: '/api/index/fundServicesList',
		method: 'GET',
		params: data,
	})
}

// 获取企业服务列表
export function enterpriseServicesList(data) {
	return request({
		url: '/api/index/enterpriseServicesList',
		method: 'GET',
		params: data,
	})
}

// 获取关于我们数据
export function aboutusList(data) {
	return request({
		url: '/api/index/aboutusList',
		method: 'GET',
		params: data,
	})
}

// 获取入驻机构数据
export function square(data) {
	return request({
		url: '/api/index/square',
		method: 'GET',
		params: data,
	})
}

// 获取基金服务详情
export function fundServicesDetails(data) {
	return request({
		url: '/api/index/fundServicesDetails',
		method: 'GET',
		params: data,
	})
}

// 获取企业服务详情
export function enterpriseServicesDetails(data) {
	return request({
		url: '/api/index/enterpriseServicesDetails',
		method: 'GET',
		params: data,
	})
}

// 获取服务案例
export function serviceCasesList(data) {
	return request({
		url: '/api/index/serviceCasesList',
		method: 'GET',
		params: data,
	})
}

// 获取活动案例详情
export function activityCasesDetails(data) {
	return request({
		url: '/api/index/activityCasesDetails',
		method: 'GET',
		params: data,
	})
}

// 获取服务案例详情
export function serviceCasesDetails(data) {
	return request({
		url: '/api/index/serviceCasesDetails',
		method: 'GET',
		params: data,
	})
}

// 获取区位优势
export function qwysEditor(data) {
	return request({
		url: '/api/index/qwysEditor',
		method: 'GET',
		params: data,
	})
}

// 获取发展历程
export function courseList(data) {
	return request({
		url: '/api/index/courseList',
		method: 'GET',
		params: data,
	})
}

// 获取成果荣誉
export function cgryContent(data) {
	return request({
		url: '/api/index/cgryContent',
		method: 'GET',
		params: data,
	})
}

// 获取服务案例
export function activityCasesList(data) {
	return request({
		url: '/api/index/activityCasesList',
		method: 'GET',
		params: data,
	})
}

// 获取底部配置
export function contactUs(data) {
	return request({
		url: '/api/index/contactUs',
		method: 'GET',
		params: data,
	})
}
// 获取政策列表
export function financial_policy_list(data) {
	return request({
		url: '/api/Indexnew/financial_policy_list',
		method: 'POST',
		params: data,
	})
}

// 获取政策列表
export function get_config(data) {
	return requests({
		url: 'api/additional/get_config',
		method: 'POST',
		params: data,
	})
}

// 获取城市列表
export function get_city_area(data) {
	return requests({
		url: 'api/index/get_city_area',
		method: 'POST',
		params: data,
	})
}

// 获取广告位列表
export function get_advertise(data) {
	return requests({
		url: 'api/enterprise/get_advertise',
		method: 'POST',
		params: data,
	})
}

// 获取公告详情
export function noticedetail(data) { 
	return requests({
		url: 'api/index/noticedetail',
		method: 'POST',
	data,
	})
}

// 获取公司
export function get_company(data) {
	return requests({
		url: 'api/interfacenew/get_company',
		method: 'POST',
		params: data,
	})
}

// 学习课程筛选项
export function getLessonFilter(data) {
	return request({
		url: 'api/index/getLessonFilter',
		method: 'GET',
		params: data,
	})
}

// 学习课程列表
export function getLessonList(data) {
	return request({
		url: 'api/index/getLessonList',
		method: 'GET',
		params: data,
	})
}

// 学习课程详情
export function getLessonInfo(data) {
	return request({
		url: 'api/index/getLessonInfo',
		method: 'GET',
		params: data,
	})
}

// 参加活动筛选项
export function getCjhdFilter(data) {
	return request({
		url: 'api/index/getCjhdFilter',
		method: 'GET',
		params: data,
	})
}

// 参加活动列表
export function getCjhdList(data) {
	return request({
		url: 'api/index/getCjhdList',
		method: 'GET',
		params: data,
	})
}

// 参加活动详情
export function getCjhdInfo(data) {
	return request({
		url: 'api/index/getCjhdInfo',
		method: 'GET',
		params: data,
	})
}

// 查项目库类型筛选列表
export function getCxmkFilter(data) {
	return request({
		url: 'api/index/getCxmkFilter',
		method: 'GET',
		params: data,
	})
}

// 查项目库类型列表
export function getCxmkList(data) {
	return request({
		url: 'api/index/getCxmkList',
		method: 'GET',
		params: data,
	})
}
// 查项目库详情
export function getCxmkInfo(data) {
	return request({
		url: 'api/index/getCxmkInfo',
		method: 'GET',
		params: data,
	})
}

// 基金入驻
export function getfundMove(data) {
	return request({
		url: 'api/index/getfundMove',
		method: 'GET',
		params: data,
	})
}

// 基金注册
export function getfundSignup(data) {
	return request({
		url: 'api/index/getfundSignup',
		method: 'GET',
		params: data,
	})
}

// 广场资讯
export function getTrendsSquare(data) {
	return request({
		url: 'api/index/getTrendsSquare',
		method: 'GET',
		params: data,
	})
}
// 广场资讯详情
export function getTrendsSquareInfo(data) {
	return request({
		url: 'api/index/getTrendsSquareInfo',
		method: 'GET',
		params: data,
	})
}

// 机构动态
export function getTrendsMechanism(data) {
	return request({
		url: 'api/index/getTrendsMechanism',
		method: 'GET',
		params: data,
	})
}
// 机构动态详情
export function getTrendsMechanismInfo(data) {
	return request({
		url: 'api/index/getTrendsMechanismInfo',
		method: 'GET',
		params: data,
	})
}

// 入住机构
export function getSettledSetup(data) {
	return request({
		url: 'api/index/getSettledSetup',
		method: 'GET',
		params: data,
	})
}
// 创投日报
export function weixin_news(data) {
	return request({
		url: 'api/index/weixin_news',
		method: 'GET',
		params: data,
	})
}


// WEBPACK FOOTER //
// ./src/api/user.js